import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import WebFont from 'webfontloader';
import * as serviceWorker from './serviceWorker';

WebFont.load({
  google: {
    families: ['Poppins:300,300i,400,400i,500,500i,600,600i,700,700i,900,900i:latin-ext&display=swap','Palanquin:300,400,700:latin-ext&display=swap', 'sans-serif']
  }
});

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
